import React from 'react';
import Navigation from '../../components/static/Navigation';
import Footer from '../../components/static/Footer';

import VBDropdown from "@vb-js-commons/new/vbDropdown";
import VBInput from "@vb-js-commons/new/vbInput";
import VBCheckbox from "@vb-js-commons/new/vbCheckbox";

import NHTabs from './components/nhTabs';
import NHBox from './components/nhBox';
import NHDivider from './components/nhDivider';
import NHInfo from './components/nhInfo';
import NHPill from './components/nhPill';
import NHForestSection from './components/nhForestSection';
import NHEdit from './components/nhEdit';
import NHAdd from './components/nhAdd';
import NHDelete from './components/nhDelete';
import NHTextCapper from './components/nhTextCapper'

import NHLeaflet from './components/nhLeaflet';
import data_map from './api';
import { TwModal } from '@ui-component-library';
import Cookies from 'js-cookie';

import txt from './components/txt';
import TxtTranslateModal from './components/txtTranslateModal';

import NHLeafletChange from './components/nhLeafletChange';
import VbTextarea from '@vb-js-commons/new/vbTextarea';

class NHDetails extends React.Component {
    constructor() {
        super();
        this.navigation = React.createRef();

        window.addEventListener("resize", () => {this.setState({trigger:"value"})});

        this.changeMap = React.createRef()

        this.refSections = {}

        Window.react_data.sections.map((itm) => {
            this.refSections[itm.id] = React.createRef()
        })



        this.state={
            activeTab:"overblick",
            crudOffCanvas: null,
            show_image_modal: false,
            selected_changes:[],
            subEmail: "",
            subTermsCheck: false,
            subMessage: ""
        }
    }

    getAttachmentBox(){
        if(Window.react_data.attachments.length  == 0 && !Window.react_data.is_editor){
            return null
        }
        return <NHBox headline={txt({global:true, text:"Bilagor"})} hidden={false}>
            {Window.react_data.attachments.map((attch, i) => {
                return <>
                <a href={attch.file} download={attch.name}>
                    <div onClick={() => {}} style={{"cursor":"pointer"}} className="flex hover-bg-neutral-cloud-300 p-1 corners-1-all justify-between items-center">
                        <div>
                            <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-1 neutral-charcoal-400">{attch.created_at_formats.iso}</p>
                            <p className="text-[13px] leading-[120%] tracking-[-0.26px] font-medium mb-0">{attch.name}</p>
                        </div>
                        <div>
                            <img src={`${Window.static_path}img/icons/arrow_down.svg`} style={{width:"12px", height:"12px"}} />
                            {Window.react_data.is_editor ? <span className="pl-2 text-[16px] leading-[125%] tracking-[-0.32px] semantic-danger-500" onClick={(e) => {e.preventDefault(); this.handleDelete("attachment", attch.id)}}>✖</span> : null}
                        </div>
                    </div>
                    
                </a>
            
            
            {Window.react_data.attachments.length -1 != i && <NHDivider extra_class="mt-1 mb-2" />}
            </>
            })}
            <NHAdd className="pt-2 pb-2" onClick={() => {this.generateCreateForm("attachment", {}, {"project_id": Window.react_data.id})}} />
    
    </NHBox>
    }

    getOtherInfoBox(){
        return <NHBox 
        headline={txt({global:true, text:"Övrig information"})}
        hidden={this.state.activeTab != "overblick"}
        can_toggle={true}
        >
            <div className="flex flex-wrap mb-2">
                <div className="w-1/4">
                    <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-1">{txt({global:true, text:"Plats"})}</p>
                    <p className="text-[16px] leading-[125%] tracking-[-0.32px] mb-0">{Window.react_data.muni}, {txt({global:true, text:Window.react_data.country})}</p>
                </div>
                {Window.react_data.start_time_formats && <div className="w-1/4">
                    <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-1">{txt({global:true, text:"Utgivningsdatum"})}</p>
                    <p className="text-[16px] leading-[125%] tracking-[-0.32px] mb-0">{Window.react_data.start_time_formats.pretty}</p>
                </div>}
                {Window.react_data.start_time_formats && <div className="w-1/4">
                    <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-1">{txt({global:true, text:"Grundat"})}</p>
                    <p className="text-[16px] leading-[125%] tracking-[-0.32px] mb-0">{Window.react_data.start_time_formats.year}</p>
                </div>}
            </div>
            <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-2" style={{whiteSpace: "pre-wrap"}}>
                <NHTextCapper max_length={512} text={txt({location_id:"project_other_info", context_clue:"Other information about a biodiversity project", text:Window.react_data.other_info})} />
            </p>
            {Window.react_data.other_info_link && <a href={Window.react_data.other_info_link} className="text-[13px] leading-[120%] tracking-[-0.26px] supp-plum">{txt({global:true, text:"Läs mer"})}</a>}

            {this.getImages()}
            <NHAdd className="absolute end-0 bottom-0 pb-6 pr-4" onClick={() => {this.generateCreateForm("image_file", {}, {"project_id": Window.react_data.id})}} />
        </NHBox>
    }

    getDetailsBox(){
        if(Window.react_data.details.length  == 0 && !Window.react_data.is_editor){
            return null
        }
        return <NHBox 
        hidden={this.state.activeTab != "overblick"}
        headline={txt({global:true, text:"Detaljer"})}
        can_toggle={true}
        >
            {Window.react_data.details.sort((a,b) => a.order - b.order).map((detail, i) => {
                return <>
                    <div className="relative">
                        <NHEdit onClick={() => {this.generateUpdateForm("detail", detail.id, detail, {"project_id": Window.react_data.id})}} className="absolute end-0 pr-1" />
                        <p className="text-[16px] leading-[125%] tracking-[-0.32px] mb-1">{txt({location_id:`ProjectDetail_title_${detail.id}`, text:detail.title})}</p>
                        <p className="text-[13px] leading-[120%] tracking-[-0.26px] m-0" style={{whiteSpace: "pre-line"}}>
                            <NHTextCapper max_length={512} text={txt({location_id:`ProjectDetail_description_${detail.id}`, text:detail.description})} />
                        </p>
                        {detail.link && <a href={detail.link} className="text-[13px] leading-[120%] tracking-[-0.26px] supp-plum flex items-center"><span>{txt({global:true, text:"Läs mer"})}</span> <img src={`${Window.static_path}img/icons/arrow_up_right.svg`} /></a>}
                    </div>
                    {Window.react_data.details.length -1 != i && <NHDivider extra_class="my-2" />}
                    </>
            })}
            <NHAdd onClick={() => {this.generateCreateForm("detail", {}, {"project_id": Window.react_data.id})}} />
        </NHBox>
    }

    get_left_side(){
        if(!Window.react_data.forest.left_side_headline){
            return null;
        }
        return <>
        <div className="relative flex justify-between" style={{height:"26px"}}>
            <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
            <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({location_id:"project_details_left_side", text:Window.react_data.forest.left_side_headline})}</p>
        </div>
        {Window.react_data.forest.left_side && Window.react_data.forest.left_side.split("\n").map((line) => {
            let title = line.split(":")[0].trim()
            let text = line.split(":")[1].trim()
            return <div className="relative flex justify-between" style={{height:"26px"}}>
                <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
                <p className="bg-neutral-cloud-100 absolute px-1 pl-4 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({location_id:`project_details_left_side_line_title_${title}`, text:title})}</p>
                <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0 end-0 flex items-center">{txt({location_id:`project_details_left_side_line_text_${text}`, text:text})}</p>
            </div>
        })}
        </>
    }

    get_right_side(){
        if(!Window.react_data.forest.right_side_headline){
            return null;
        }
        return <>
        <div className="relative flex justify-between" style={{height:"26px"}}>
            <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
            <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({location_id:"project_details_right_side", text:Window.react_data.forest.right_side_headline})}</p>
        </div>
        {Window.react_data.forest.right_side && Window.react_data.forest.right_side.split("\n").map((line) => {
            let title = line.split(":")[0].trim()
            let text = line.split(":")[1].trim()
            return <div className="relative flex justify-between" style={{height:"26px"}}>
                <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
                <p className="bg-neutral-cloud-100 absolute px-1 pl-4 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({location_id:`project_details_right_side_line_title_${title}`, text:title})}</p>
                <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0 end-0 flex items-center">{txt({location_id:`project_details_right_side_line_text_${text}`, text:text})}</p>
            </div>
        })}
        </>
    }

    getAboutBox(){
        return <NHBox  headline={txt({global:true, location_id:"title_about_biodiversity_project", text:"Om projektet"})} hidden={this.state.activeTab != "overblick"}>
        <p className="text-[16px] leading-[125%] tracking-[-0.32px]" style={{whiteSpace: "pre-wrap"}}><NHTextCapper max_length={512} text={txt({location_id:"project_nature_description", context_clue:"A short summary of a biodiversity project", text:Window.react_data.nature_description})} /></p>
        <NHDivider />
        <div className="mt-4">
            <div className="flex flex-wrap">
                <div className="lg:w-1/2 w-full">
                    <div className="relative flex justify-between" style={{height:"26px"}}>
                        <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({global:true, text:"Kommun"})}</p>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0 end-0">{Window.react_data.muni}</p>
                    </div>
                    <div className="relative flex justify-between" style={{height:"26px"}}>
                        <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({global:true, text:"Län"})}</p>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0 end-0">{Window.react_data.region}</p>
                    </div>
                    {Window.react_data.owner_count != 0 && <div className="relative flex justify-between" style={{height:"26px"}}>
                        <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({global:true, text:"Antal Ägare"})}</p>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0 end-0">{Window.react_data.owner_count}</p>
                    </div>}
                    {Window.react_data.forest ? 
                    this.get_left_side()
                    :null}
                </div>
                <div className="lg:w-1/2 w-full">
                    {Window.react_data.forest ? this.get_right_side() :null}
                    {Window.react_data.certified && <div className="relative flex justify-between" style={{height:"26px"}}>
                        <div className="w-full bg-neutral-cloud-300 absolute" style={{height:"1px", bottom:"4px"}}></div>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0">{txt({global:true, text:"Certifiering"})}</p>
                        <p className="bg-neutral-cloud-100 absolute px-1 mb-0 text-[13px] leading-[120%] tracking-[-0.26px] bottom-0 end-0 flex items-center">{txt({global:true, text:"Ja"})}</p>
                    </div>}
                </div>
            </div>
        </div>
    </NHBox>
    }

    getSectionsBox(){
        if(Window.react_data.sections.length  == 0 && !Window.react_data.is_editor){
            return null
        }
        return <NHBox 
        headline={txt({global:true, location_id:"biodiversity_project_sections_title", context_clue:"biodiversity project forest sections", text:"Avdelningar"})}
        hidden={this.state.activeTab != "overblick"}
        can_toggle={true}
        >
            {Window.react_data.forest ? <NHEdit 
            className="py-2" 
            onClick={() => {this.generateUpdateForm("forest", Window.react_data.forest.id, Window.react_data.forest)}} /> :
            <NHAdd 
            className="py-2" 
            onClick={() => {this.generateCreateForm("forest", {}, {"project_id": Window.react_data.id})}} />
            }
            {Window.react_data.sections.sort((a,b) => a.name.localeCompare(b.name)).map((sect) => {
                return <NHForestSection ref={this.refSections[sect.id]} deleteImage={(img_id)=>{this.handleDelete("image_file", img_id)}} addImage={() => {this.generateCreateForm("image_file", {}, {"forest_section_id": sect.id})}} edit={() => {this.generateUpdateForm("forest_section", sect.id, sect)}} data={sect} />;
            })}
            {Window.react_data.forest ? <NHAdd 
            className="py-2" 
            onClick={() => {this.generateCreateForm("forest_section", {}, {"forest_id": Window.react_data.forest.id})}} /> : null}
        </NHBox>
    }

    getUpdateBox(){
        if(Window.react_data.updates.length  == 0 && !Window.react_data.is_editor){
            return null
        }
        return <NHBox 
            headline={txt({global:true, location_id:"biodiv_updates", text:"Uppdateringar"})}
            hidden={this.state.activeTab != "overblick" && this.state.activeTab != "aktivitet"}
            >
                {Window.react_data.updates.sort((a,b) => Number(b.date_formats.timestamp) - Number(a.date_formats.timestamp)).map((itm) => {
                    return <div className="flex w-full relative">
                        <NHDelete 
                        className="absolute end-0 top-0 pt-4 pr-4" 
                        onClick={() => {this.handleDelete("update", itm.id)}} />
                    <div className="relative" style={{paddingLeft:"56px"}}>
                        <div className="h-full bg-neutral-cloud-300 absolute" style={{width:"2px", left:"19px"}}></div>
                        <div className="bg-neutral-cloud-300 corners-2-all absolute start-0 flex flex-wrap items-center" style={{width:"40px", height:"40px"}}>
                            <p className="text-center font-bold text-[10px] leading-[120%] tracking-[-0.2px] mb-0 w-full">{itm.date_formats.day}<br/><span className="font-medium">{txt({global:true, context_clue:"Short format month name", text:itm.date_formats.month_name_short.toUpperCase()})}</span></p>
                        </div>
                        <p className="font-medium text-[13px] leading-[120%] tracking-[-0.26px] mb-1">{txt({location_id:`ProjectUpdate_title_${itm.id}`, context_clue:"The title of a biodiversity project", text:itm.title})} - {itm.written_by.public_name}</p>
                        <ul className="mb-0 text-[13px] leading-[120%] tracking-[-0.26px] pl-6 pb-2">
                            {itm.items.map((itm2) => {
                                return <li>{txt({location_id:`ProjectUpdateSingle_description_${itm2.id}`, context_clue:"One description line of a bigger project updates segment", text:itm2.description})}</li>
                            })}
                        </ul>
                    </div>
                </div>
                })}
                <NHAdd onClick={() => {this.generateCreateForm("update", {}, {"project_id": Window.react_data.id, "written_by_id": Window.react_data.editor_id})}} />
        </NHBox>
    }

    getTimelineBox(){
        return <NHBox bg="bg-neutral-stone-100" hidden={this.state.activeTab != "tidslinje"}>
        <div className="flex mb-4">
            <div className="flex items-center mr-6">
                <div className="p-2 bg-neutral-stone-300 mr-2 corners-1-all">
                    <img style={{width:"20px", height:"20px"}} src="https://placehold.co/20x20" />
                </div>
                <div>
                    <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-0">Sep 14, 2024</p>
                    <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">Startar</p>
                </div>
            </div>
            <div className="flex items-center mr-6">
                <div className="p-2 bg-neutral-stone-300 mr-2 corners-1-all">
                    <img style={{width:"20px", height:"20px"}} src="https://placehold.co/20x20" />
                </div>
                <div>
                    <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-0">20 år</p>
                    <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">Förväntad tidsperiod</p>
                </div>
            </div>
        </div>
        <NHDivider />
        <div className="mt-4 px-2">
            <div className="relative" style={{paddingLeft:"35px"}}>
                {/* only visual */}
                <div className="absolute h-full bg-supp-pine" style={{width:"2px", left:"14px"}}></div>
                <div className="flex items-center justify-center absolute bg-supp-pine rounded-full top-0" style={{width:"16px", height:"16px", left:"7px"}}>
                    <img src="https://placehold.co/8x8" style={{width:"8px", height:"8px"}} />
                </div>

                {/* content */}
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">14 Apr. 2024</p>
                <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-2">Data uploaded</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] font-medium mb-0">Subtitle</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-0 pb-2">Amet magna nulla a semper. Lacus nisi molestie sed lobortis enim tempor sit. Arcu morbi faucibus nec malesuada et aliquam ac blandit. Nam sed magna urna massa tortor felis eu pellentesque augue.</p>
            </div>
            <div className="relative" style={{paddingLeft:"35px"}}>
                {/* only visual */}
                <div className="absolute h-full bg-supp-pine" style={{width:"2px", left:"14px"}}></div>
                <div className="flex items-center justify-center absolute bg-supp-pine rounded-full top-0" style={{width:"16px", height:"16px", left:"7px"}}>
                    <img src="https://placehold.co/8x8" style={{width:"8px", height:"8px"}} />
                </div>

                {/* content */}
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">14 Apr. 2024</p>
                <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-2">Data uploaded</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] font-medium mb-0">Subtitle</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-0 pb-2">Amet magna nulla a semper. Lacus nisi molestie sed lobortis enim tempor sit. Arcu morbi faucibus nec malesuada et aliquam ac blandit. Nam sed magna urna massa tortor felis eu pellentesque augue.</p>
            </div>
            <div className="relative" style={{paddingLeft:"35px"}}>
                {/* only visual */}
                <div className="flex items-center justify-center absolute bg-supp-pine rounded-full top-0" style={{width:"24px", height:"24px", left:"3px"}}>
                    <img src="https://placehold.co/16x16" style={{width:"16px", height:"16px"}} />
                </div>

                {/* content */}
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">14 Apr. 2024</p>
                <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-2">Data uploaded</p>
            </div>
        </div>
        <div className="mt-4 px-2">
            <div className="relative" style={{paddingLeft:"35px"}}>
                {/* only visual */}
                <div className="absolute h-full bg-supp-pine" style={{width:"2px", left:"14px"}}></div>
                <div className="flex items-center justify-center absolute bg-supp-pine rounded-full top-0" style={{width:"16px", height:"16px", left:"7px"}}>
                    <img src="https://placehold.co/8x8" style={{width:"8px", height:"8px"}} />
                </div>

                {/* content */}
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">14 Apr. 2024</p>
                <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-2">Data uploaded</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] font-medium mb-0">Subtitle</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-0 pb-2">Amet magna nulla a semper. Lacus nisi molestie sed lobortis enim tempor sit. Arcu morbi faucibus nec malesuada et aliquam ac blandit. Nam sed magna urna massa tortor felis eu pellentesque augue.</p>
            </div>
            <div className="relative" style={{paddingLeft:"35px"}}>
                {/* only visual */}
                <div className="absolute h-full bg-supp-pine" style={{width:"2px", left:"14px"}}></div>
                <div className="flex items-center justify-center absolute bg-supp-pine rounded-full top-0" style={{width:"16px", height:"16px", left:"7px"}}>
                    <img src="https://placehold.co/8x8" style={{width:"8px", height:"8px"}} />
                </div>

                {/* content */}
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">14 Apr. 2024</p>
                <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-2">Data uploaded</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] font-medium mb-0">Subtitle</p>
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-0 pb-2">Amet magna nulla a semper. Lacus nisi molestie sed lobortis enim tempor sit. Arcu morbi faucibus nec malesuada et aliquam ac blandit. Nam sed magna urna massa tortor felis eu pellentesque augue.</p>
            </div>
            <div className="relative" style={{paddingLeft:"35px"}}>
                {/* only visual */}
                <div className="flex items-center justify-center absolute bg-supp-pine rounded-full top-0" style={{width:"24px", height:"24px", left:"3px"}}>
                    <img src="https://placehold.co/16x16" style={{width:"16px", height:"16px"}} />
                </div>

                {/* content */}
                <p className="text-[13px] leading-[120%] tracking-[-0.26px] neutral-charcoal-400 mb-0">14 Apr. 2024</p>
                <p className="text-[16px] leading-[125%] tracking-[-0.32px] font-medium mb-2">Data uploaded</p>
            </div>
        </div>

    </NHBox>;
    }

    getRelatedProjectBox(){
        const colors =[
            ["bg-supp-plum", "white"],
            ["bg-neutral-stone", "black"],
            ["bg-neutral-charcoal", "white"],
            ["bg-supp-forest-green", "white"]
        ]
        return <><h3 className="text-[20px] leading-[120%] tracking-[-0.4px] mb-6">{txt({global:true, text:"Relaterade projekt"})}</h3>
        <div className="w-full mb-6 [&::-webkit-scrollbar]:hidden [&::-webkit-scrollbar]:w-0 [&::-webkit-scrollbar]:bg-transparent" style={{overflowX:"auto", overflowY:"hidden"}}>
        <div className="flex">
            {Window.react_data.related_projects.slice(0,3).map((itm, i) => {
                return <div style={{cursor:"pointer", width:(screen.width >= 992 ? "calc(25% - 20px)" : "224px")}} onClick={() => {window.location = "/"+ itm.attribute_label +"/" + itm.id + "/"}} className="shrink-0 mr-4">
                <div className={`corners-2-all ${colors[i][0]} relative p-4 inline-block lg:block`} style={{height:"212px"}}>
                    <span className={`${colors[i][0]}-300 ${colors[i][1]} rounded-3xl py-1 px-2 text-[10px] leading-[120%] tracking-[-0.2px]`}>{txt({global:true, text:itm.tag})}</span>
                    <h4 className={`${colors[i][1]} text-[16px] leading-[125%] tracking-[-0.32px] mt-2`}>{txt({location_id:"project_title", context_clue:"Biodiversity project title", text:itm.title})} - {itm.property_designation}</h4>
                    <span className={`${colors[i][0]}-300 font-medium ${colors[i][1]} rounded-3xl py-1 px-2 text-[16px] leading-[125%] tracking-[-0.32px] absolute bottom-0 mb-4`}>{itm.end_time_formats ? itm.end_time_formats.pretty : ""}</span>
                </div>
            </div>
            })}
        </div>
        </div></>
    }

    getBuyBox(){
        return <NHBox hidden={false}>
        <div className="flex justify-between">
            <p className="flex items-center text-[13px] leading-[120%] tracking-[-0.26px] n-lg-fs-6"><img className="pr-1" src={`${Window.static_path}img/icons/sun.svg`} style={{height:"20px"}} /> {txt({global:true, text:"Status"})}</p>
            <p className="flex items-center"><NHPill bg={Window.react_data.state < 40 ? "bg-neutral-stone" :"bg-semantic-success"} font_size="text-[13px] leading-[120%] tracking-[-0.26px] n-lg-fs-6" font_weight="font-normal" text={txt({global:true, location_id:`project_state_${Window.react_data.state_name}`, text:Window.react_data.state_name})} icon={`${Window.static_path}img/icons/icon_circle.svg`} /></p>
        </div>
        <div className="flex justify-between">
            <p className="flex items-center text-[13px] leading-[120%] tracking-[-0.26px] n-lg-fs-6"><img className="pr-1" src={`${Window.static_path}img/icons/timer.svg`} style={{height:"20px"}} /> {txt({global:true, location_id:"project_length_title", text:"Projektlängd"})}</p>
            <p className="flex items-center text-[13px] leading-[120%] tracking-[-0.26px] n-lg-fs-6">{Window.react_data.project_length} {Window.react_data.project_length_unit} <NHInfo title={txt({global:true, text:"Projektlängd"})} body={txt({global:true, location_id:"project_length_info_text", context_clue:"Description of how the project length works", text:"Projektet pågår ett visst antal år, ofta med möjlighet till förnyelse av köparen. Det betyder att skogen inte är skyddas i en evighet utan kan återgå till skogsägaren efter perioden är över."})} /></p>
        </div>
        <NHDivider extra_class="mt-1 mb-2" />
        {Window.react_data.buy_link && <a href={Window.react_data.buy_link} className="transition-all duration-300 ease-out text-[1em] text-center py-[11px] px-8 rounded-[30px] border text-white bg-[#023436] border-[#023436] max-[992px]:py-[11px] max-[992px]:px-6 max-[992px]:text-[.8em] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#144143] enabled:hover:border-[#144143] enabled:active:bg-[#012526] enabled:active:border-[#012526] w-full block">{txt({global:true, text:"Kontakt för köp"})}</a>}
        <p className="text-center my-4"><span className="neutral-charcoal-400">{txt({global:true, text:"Frågor?"})}</span> <a href="mailto:information@treebula.se" className="underline">{txt({global:true, text:"Kontakta oss"})}</a></p>
    </NHBox>
    }

    getContactBox(){
        return <NHBox headline={Window.react_data.project_manager ? txt({global:true, localtion_id:"contact_project_owner", text:"Projektägare"}) : ""} hidden={false}>
        {Window.react_data.project_manager ? <NHEdit 
        className="absolute end-0 top-0 pt-4 pr-4" 
        onClick={() => {this.generateUpdateForm("project_manager", Window.react_data.project_manager.id, Window.react_data.project_manager)}} />
        : <NHAdd className="absolute end-0 top-0 pt-4 pr-4" 
        onClick={() => {this.generateCreateForm("project_manager", {}, {"project_id": Window.react_data.id})}} /> }
        {Window.react_data.project_manager && <><div className="flex items-center">
            <img src={`${Window.react_data.project_manager.picture}`} className="rounded-full" style={{objectFit:"cover", height:"48px"}} />
            <p className="text-[13px] leading-[120%] tracking-[-0.26px] ml-1 mb-0">
                {Window.react_data.project_manager.public_name}<br/>
                <a className="neutral-charcoal-400">{Window.react_data.project_manager.public_email}</a>
            </p>
        </div>
        <NHDivider extra_class="mt-1 mb-2" /></>}

        {Window.react_data.links.length > 0 || Window.react_data.is_editor ? <>
        <h3 className="text-[20px] leading-[120%] tracking-[-0.4px] font-medium mb-4">{txt({global:true, text:"Länkar"})}</h3>
        <div className="flex flex-wrap w-full relative">
            {Window.react_data.links.map((lnk) => {
                return <>
                <NHPill 
                    delete={Window.react_data.is_editor ? () => {this.handleDelete("project_link", lnk.id)} : undefined}
                    extra_class="mr-2 mb-2" 
                    link={lnk.link} 
                    text={lnk.name} 
                    icon={`${Window.static_path}${lnk.icon}`} />
                </>;
            })}
            <NHAdd 
            className="pt-2 w-full" 
            onClick={() => {this.generateCreateForm("project_link", {}, {"project_id": Window.react_data.id})}} />
        </div>
        <NHDivider extra_class="mt-1 mb-2" />
        </>: null}
        {Window.react_data?.linkedin_link || Window.react_data?.instagram_link || Window.react_data?.facebook_link ? <>
        <h3 className="text-[20px] leading-[120%] tracking-[-0.4px] font-medium mb-4">{txt({global:true, text:"Sociala Medier"})}</h3>
        <div className="flex flex-wrap w-full">
            {Window.react_data?.linkedin_link && <NHPill link={Window.react_data.linkedin_link} extra_class="mr-2 mb-2" text="LinkedIn" icon={`${Window.static_path}img/social/linkedin.svg`} />}
            {Window.react_data?.instagram_link && <NHPill link={Window.react_data.instagram_link} extra_class="mr-2 mb-2" text="Instagram" icon={`${Window.static_path}img/social/instagram.svg`} />}
            {Window.react_data?.facebook_link && <NHPill link={Window.react_data.facebook_link} extra_class="mr-2 mb-2" text="Facebook" icon={`${Window.static_path}img/social/facebook.svg`} />}
        </div>
        <NHDivider extra_class="mt-1 mb-2" />
        </> : null}
        <h3 className="text-[20px] leading-[120%] tracking-[-0.4px] font-medium mb-4 mb-2">{txt({global:true, text:"Kontakt"})}</h3>
        <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-4">{txt({global:true, location_id:"contact_box_contact_copy", context_clue:"Text describing how to contact", text:"För förfrågningar eller samarbetsmöjligheter, vänligen kontakta oss via e-post på"})} {Window.react_data.company ? Window.react_data.company.company_email : "information@treebula.se"}.</p>
        <div className="px-4 py-2 bg-neutral-cloud-300 inline-block corners-1-all">
            <img style={{width:"137px"}} src={Window.react_data.company ? Window.react_data.company.company_logo : `${Window.static_path}img/icons/treebula_lockup_charcoal.svg`}/>
        </div>
        {Window.react_data.company ? 
        <NHEdit className="pt-2 w-full" onClick={() => {this.generateUpdateForm("project_company", Window.react_data.company.id, Window.react_data.company)}} />
        :<NHAdd className="pt-2 w-full" onClick={() => {this.generateCreateForm("project_company", {}, {"project_id": Window.react_data.id})}} />
        }
    </NHBox>
    }

    getNewsletterBox(){
        return <NHBox headline={txt({global:true, location_id:"sub_newsletter_updates", text:"Uppdateringar"})} hidden={false}>
        <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-6">{txt({global:true, location_id:"newsletter_subscribe_title", text:"Anmäl dig och få de senaste uppdateringarna om projektet."})}</p>
        {this.state.subMessage && <p className="text-[16px] leading-[125%] tracking-[-0.32px]">{this.state.subMessage}</p>}
        <VBInput 
            placeholder={txt({global:true, context_clue:"Input field placeholder for email", text:"Ange mailadress"})}
            onChange={(val) => {this.setState({subEmail:val})}}
            type="email"
        />
        <div className='flex items-center my-2'>
            <VBCheckbox
                label=""
                initial={false}
                onChange={(val) => {this.setState({subTermsCheck:val})}}
                 />
            <p className='mb-0 text-[13px] leading-[120%] tracking-[-0.26px]' >{txt({location_id:"newsletter_terms_text", context_clue:"Terms for subscribing to newsletter", text:'Genom att klicka på "Prenumerera", bekräftar du att ha tagit del av våra'})} <a className="underline" href="/terms/">{txt({global:true, text:'"användarvillkor"'})}</a> & <a className="underline" href="/privacy/">{txt({global:true, text:'"integritetspolicy"'})}</a>.</p>
        </div>
        <a className="transition-all duration-300 ease-out text-[1em] text-center py-[11px] px-8 rounded-[30px] border text-white bg-[#023436] border-[#023436] max-[992px]:py-[11px] max-[992px]:px-6 max-[992px]:text-[.8em] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#144143] enabled:hover:border-[#144143] enabled:active:bg-[#012526] enabled:active:border-[#012526] w-full inline-block" onClick={() => {this.subEmailUpdate()}}>{txt({global:true, text:"Prenumerera"})}</a>
    </NHBox>
    }

    getTabs(){
        return <div>
            {/* tabs */}
            <NHTabs onChange={(itm) => {this.setState({activeTab:itm})}} activeDefault={this.state.activeTab} tabs={[["overblick", txt({global:true, location_id:"bio_tab_overblick", text:'Överblick'})], ["bilagor",txt({global:true, location_id:'bio_tab_bilagor', text:'Bilagor'})], ["forandringsanalys", txt({global:true, location_id:'bio_tab_change', text:'Förändringaranalys'})], ["aktivitet", txt({global:true, location_id:'bio_tab_activity', text:'Aktivitet'})]]} />
        </div>
    }

    getTopBar(){
        return <div className="corners-1-et corners-1-st bg-lg-neutral-cloud-200 bg-white p-2 flex [&::-webkit-scrollbar]:hidden [&::-webkit-scrollbar]:w-0 [&::-webkit-scrollbar]:bg-transparent" style={{overflowY:"hidden", overflowX:"auto"}}>
        <div className="flex bg-neutral-cloud-200 corners-2-all p-2 lg:p-0 m-2 lg:m-0" style={{width:(screen.width >= 992 ? "192px" : "auto"), height:(screen.width >= 992 ? "36px" : "auto")}}>
            <span className="p-2 rounded-md bg-neutral-cloud-300 mr-2 items-center justify-center hidden lg:flex">
                <img src={`${Window.static_path}img/icons/hash.svg`} />
            </span>
            <div>
                <p className="font-medium m-0 w-full text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">#NH{Window.react_data.id}</p>
                <p className="neutral-pebble m-0 text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">{txt({global:true, text:"Biodiversitets nr."})}</p>
            </div>
        </div>
        <div className="flex bg-neutral-cloud-200 corners-2-all p-2 lg:p-0 m-2 lg:m-0" style={{width:(screen.width >= 992 ? "192px" : "auto"), height:(screen.width >= 992 ? "36px" : "auto")}}>
            <span className="p-2 rounded-md bg-neutral-cloud-300 mr-2 items-center justify-center hidden lg:flex">
                <img src={`${Window.static_path}img/icons/map_pin.svg`} />
            </span>
            <div>
                <p className="font-medium m-0 w-full text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">{Window.react_data.muni}, {txt({global:true, text:Window.react_data.country})}</p>
                <p className="neutral-pebble m-0 text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">{txt({global:true, text:"Plats"})}</p>
            </div>
        </div>
        <div className="flex bg-neutral-cloud-200 corners-2-all p-2 lg:p-0 m-2 lg:m-0" style={{width:(screen.width >= 992 ? "192px" : "auto"), height:(screen.width >= 992 ? "36px" : "auto")}}>
            <span className="p-2 rounded-md bg-neutral-cloud-300 mr-2 items-center justify-center hidden lg:flex">
                <img src={`${Window.static_path}img/icons/corners_out.svg`} />
            </span>
            <div>
                <p className="font-medium m-0 w-full text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">{Window.react_data.area ? Number(Window.react_data.area).toFixed(1) : 0} ha</p>
                <p className="neutral-pebble m-0 text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">{txt({global:true, location_id:"size_hectares", text:"Storlek"})}</p>
            </div>
        </div>
        {Window.react_data.end_time_formats && <div className="flex bg-neutral-cloud-200 corners-2-all p-2 lg:p-0 m-2 lg:m-0" style={{width:(screen.width >= 992 ? "192px" : "auto"), height:(screen.width >= 992 ? "36px" : "auto")}}>
            <span className="p-2 rounded-md bg-neutral-cloud-300 mr-2 items-center justify-center hidden lg:flex">
                <img src={`${Window.static_path}img/icons/calendar_x.svg`} />
            </span>
            <div>
                <p className="font-medium m-0 w-full text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">{Window.react_data.end_time_formats.pretty}</p>
                <p className="neutral-pebble m-0 text-[13px] leading-[120%] tracking-[-0.26px] whitespace-nowrap">{txt({global:true, text:"Slutdatum"})}</p>
            </div>
        </div>}
    </div>
    }

    getImageSentinel(change_id, after=false){
        let headers = {
            'credentials': 'same-origin',
            'X-CSRFToken': Cookies.get('csrftoken'),
            'Content-Type': "application/json"
            }
        fetch('/naturehub/api/get-image/', {
            method:"POST",
            headers:headers,
            body: JSON.stringify({"change_id": change_id, "after":after})
        }).then(resp => resp.json()).then((json) => {
            let bbox = json.bbox.split(",")
            let bounds = [[bbox[1], bbox[0]], [bbox[3], bbox[2]]]
            var imageOverlay = L.imageOverlay(json.b64, bounds);
            this.changeMap.current.addImageOverlayToMap(imageOverlay);

        })
    }

    getChangeAnalysis(){
        return <div className={`corners-1-all bg-neutral-cloud-300 mb-4 relative mt-2`}>
            <div className="w-full">
                <div className="flex flex-wrap flex-col-reverse lg:flex-row gap-3">
                    <div className="w-full lg:w-5/12 [&::-webkit-scrollbar]:hidden [&::-webkit-scrollbar]:w-0 [&::-webkit-scrollbar]:bg-transparent" style={{maxHeight:"667px", overflowY:"auto"}}>
                        {screen.width >= 992 ? <div className="p-4 mb-2 bg-white corners-2-all">
                            <p className="font-medium text-[13px] leading-[120%] tracking-[-0.26px] mb-1">{txt({global:true, text:"Förändringsanalys"})}</p>
                            <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-0">{txt({global:true, text:"I den här vyn kommer du att kunna se Treebulas analys av förändringar som sker på fastigheten över tid. Du får tillgång till en komplett historik som visar vad som har ändrats, och du kan välja en viss tidpunkt för att se detaljer om förändringarna."})}</p>
                        </div>: null}
                        {Window.react_data.changes.map((itm) => {
                            return <div onClick={() => {
                                if(this.state.selected_changes.includes(itm.id)){
                                    this.changeMap.current.removeLayer(itm.id)
                                    let indx = this.state.selected_changes.indexOf(itm.id)
                                    this.state.selected_changes.splice(indx, 1)
                                    this.setState({selected_changes:this.state.selected_changes})
                                    return;
                                }
                                this.changeMap.current.addGeojsonToMap(itm.geojson, itm.id); 
                                this.state.selected_changes.push(itm.id)
                                this.setState({selected_changes:this.state.selected_changes})
                                }} style={{"cursor":"pointer"}} className={`flex flex-wrap justify-between items-center p-4 corners-2-all mb-2 bg-white`}>
                                <div className="flex items-center">
                                    <div className={`p-2 mr-2 bg-semantic-warning-50 corners-1-all`}>
                                        <img style={{width:"24px"}} src={Window.static_path+"img/icons/Warning.svg"} />
                                    </div>
                                    <div className="mr-4">
                                        <p className="text-[13px] leading-[120%] tracking-[-0.26px] mb-0">{itm.date_formats.iso}</p>
                                        <p className="text-[16px] leading-[125%] tracking-[-0.32px] mb-0 font-medium">{txt({location_id:`ProjectForestChange_title_${itm.id}`, context_clue:"Detected change in forest data short description (Title)", text:itm.title})}</p>
                                    </div>
                                    <div 
                                        style={{width:"16px", "height":"16px"}} 
                                        className="corners-1-all border border-supp-pine flex items-center justify-center">
                                        <div
                                        style={{width:"10px", "height":"10px"}}
                                        className={`corners-1-all ${this.state.selected_changes.includes(itm.id) ? "bg-supp-pine" : ""}`}></div>   
                                    </div>
                                </div>
                                
                                {(this.state.selected_changes.includes(itm.id)) && <NHDivider extra_class="mt-1 mb-2" />}
                                <p 
                                style={{height:this.state.selected_changes.includes(itm.id) ? "auto":"0", transition:"300ms", overflow:"hidden"}} 
                                className={`w-full text-[13px] leading-[120%] tracking-[-0.26px] mb-2`}>{txt({location_id:`ProjectForestChange_description_${itm.id}`, context_clue:"Detected change in forest data long description", text:itm.description})}</p>
                                {(this.state.selected_changes.includes(itm.id) && itm.image_before_date) && <div className="flex w-full justify-between">
                                    <button className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-[#2a2e33] bg-transparent border-[#023436] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[rgba(12,54,54,0.07)] enabled:active:bg-[rgba(3,51,53,0.26)] text-[13px] leading-[120%] tracking-[-0.26px] !p-2" onClick={(e)=>{e.stopPropagation(); this.getImageSentinel(itm.id)}}>{txt({global:true, location_id:"change_analysis_before_image", context:"Button for showing before change sattelite image", text:"Visa före bild"})}</button>
                                    <button className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-[#2a2e33] bg-transparent border-[#023436] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[rgba(12,54,54,0.07)] enabled:active:bg-[rgba(3,51,53,0.26)] text-[13px] leading-[120%] tracking-[-0.26px] !p-2" onClick={(e)=>{e.stopPropagation(); this.getImageSentinel(itm.id, true)}}>{txt({global:true, location_id:"change_analysis_after_image", context:"Button for showing after change sattelite image", text:"Visa efter bild"})}</button>
                                </div>}
                            </div>
                        })}
                    </div>

                    <div className="lg:w-7/12 w-full relative mb-2" style={{height:screen.width > 992 ? "667px" : "450px"}}>
                        <NHLeafletChange ref={this.changeMap} sections={Window.react_data.sections} geojson={Window.react_data?.forest?.geom} />
                    </div>
                    
                </div>
            </div>
        </div>
    }

    getImages(){
        if(Window.react_data.images.length == 0){
            return
        }

        let has_names = false

        let unique_photographer_names = Window.react_data.images.reduce((acum,img) => {
            if(!acum.includes(img.photographer_name)){
                if(img.photographer_name){
                    acum.push(img.photographer_name)
                    has_names = true
                }
            } 
            return acum
        }, [])


        let photographers = has_names && <div className="w-full"><p className="text-[13px] leading-[120%] tracking-[-0.26px] mt-1">{txt({global:true, text:"Fotografer"})}: {unique_photographer_names.join(", ")}</p></div>

        let modal = <TwModal isOpen={this.state.show_image_modal}>
            <TwModal.Header>
                <div className="flex justify-between items-start">
                    <h5 className="mb-0">{txt({global:true, text:"Bilder"})}</h5>
                    <button type="button" className="ml-auto text-[20px] leading-[120%] tracking-[-0.4px] leading-none" onClick={() => this.setState({show_image_modal:false})} aria-label="Close">&times;</button>
                </div>
            </TwModal.Header>
            <TwModal.Content>{Window.react_data.images.map(img => <div className="relative">
                <img src={img.image} className="block w-full px-1" /> 
                {img.photographer_name && <p className="mb-2 mt-1 text-[13px] leading-[120%] tracking-[-0.26px]">{txt({global:true, text:"Fotograf"})}: {img.photographer_name}</p>}
                {Window.react_data.is_editor ? <button className="absolute top-0 mr-2 mt-1 right-0 transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-[#2a2e33] bg-[#FF5B6C] border-[#FF5B6C] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#E85362] enabled:hover:border-[#E85362] enabled:active:bg-[#B5414D] enabled:active:border-[#B5414D]" onClick={() => {this.handleDelete("image_file", img.id)}}>Delete image</button> : null}
                </div>)}</TwModal.Content>
            <TwModal.Footer></TwModal.Footer>
        </TwModal>;
        if(screen.width <= 992){
            return <div className="flex flex-wrap">
                {modal}
                <div className="w-full relative" style={{height:"260px"}}>
                    <img src={Window.react_data.images[0].image} className="w-full" style={{height:"260px", objectFit:"cover"}} />
                    <button onClick={() => {this.setState({show_image_modal:true})}} className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542] absolute" style={{top:"50%", left:"50%", transform:"translate(-50%,-50%)"}}>{txt({global:true, context_clue:"Show all images button text", text:"Visa alla bilder"})}</button>
                </div>
                {photographers}
            </div>
        }
        if(Window.react_data.images.length == 1){
            return <div className="flex flex-wrap gap-2 mt-2">
                {modal}
                <div className="w-full relative" style={{height:"530px"}}>
                    <img src={Window.react_data.images[0].image} className="w-full" style={{height:"530px", objectFit:"cover"}} />
                    <button onClick={() => {this.setState({show_image_modal:true})}} className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542] absolute" style={{top:"50%", left:"50%", transform:"translate(-50%,-50%)"}}>{txt({global:true, context_clue:"Show all images button text", text:"Visa alla bilder"})}</button>
                </div>
                {photographers}
            </div>
        } else if(Window.react_data.images.length == 2){
            return <div className="flex flex-wrap gap-2 mt-2">
                {modal}
            <div className="w-1/2" style={{height:"530px"}}>
                <img src={Window.react_data.images[0].image} className="w-full" style={{height:"530px", objectFit:"cover"}} />
            </div>
            <div className="w-1/2 relative" style={{height:"530px"}}>
                <img src={Window.react_data.images[1].image} className="w-full" style={{height:"530px", objectFit:"cover"}} />
                <button onClick={() => {this.setState({show_image_modal:true})}} className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542] absolute" style={{top:"50%", left:"50%", transform:"translate(-50%,-50%)"}}>{txt({global:true, context_clue:"Show all images button text", text:"Visa alla bilder"})}</button>
            </div>
            {photographers}
        </div>
        } else if(Window.react_data.images.length == 3){
            return <div className="flex flex-wrap gap-2 mt-2">
                {modal}
                <div className="w-1/3" style={{height:"530px"}}>
                    <img src={Window.react_data.images[0].image} className="w-full" style={{height:"260px", objectFit:"cover", marginBottom:"10px"}} />
                    <img src={Window.react_data.images[1].image} className="w-full" style={{height:"260px", objectFit:"cover"}} />
                </div>
                <div className="w-2/3 relative" style={{height:"530px"}}>
                    <img src={Window.react_data.images[2].image} className="w-full" style={{height:"530px", objectFit:"cover"}} />
                    <button onClick={() => {this.setState({show_image_modal:true})}} className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542] absolute" style={{top:"50%", left:"50%", transform:"translate(-50%,-50%)"}}>{txt({global:true, context_clue:"Show all images button text", text:"Visa alla bilder"})}</button>
                </div>
                {photographers}
            </div>
        } else if(Window.react_data.images.length == 4){
            return <div className="flex flex-wrap gap-2 mt-2">
                {modal}
                <div className="w-1/2" style={{height:"530px"}}>
                    <img src={Window.react_data.images[0].image} className="w-full" style={{height:"260px", objectFit:"cover", marginBottom:"10px"}} />
                    <img src={Window.react_data.images[1].image} className="w-full" style={{height:"260px", objectFit:"cover"}} />
                </div>
                <div className="w-1/2 relative" style={{height:"530px"}}>
                    <img src={Window.react_data.images[2].image} className="w-full" style={{height:"260px", objectFit:"cover", marginBottom:"10px"}} />
                    <img src={Window.react_data.images[3].image} className="w-full" style={{height:"260px", objectFit:"cover"}} />
                    <button onClick={() => {this.setState({show_image_modal:true})}} className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542] absolute" style={{top:"75%", left:"50%", transform:"translate(-50%,-50%)"}}>{txt({global:true, context_clue:"Show all images button text", text:"Visa alla bilder"})}</button>
                </div>
                {photographers}
            </div>
        }
        return <div className="flex flex-wrap gap-2 mt-2">
            {modal}
            <div className="w-1/3" style={{height:"530px"}}>
                <img src={Window.react_data.images[0].image} className="w-full" style={{height:"170px", objectFit:"cover", marginBottom:"10px"}} />
                <img src={Window.react_data.images[1].image} className="w-full" style={{height:"170px", objectFit:"cover", marginBottom:"10px"}} />
                <img src={Window.react_data.images[2].image} className="w-full" style={{height:"170px", objectFit:"cover"}} />
            </div>
            <div className="w-2/3 relative" style={{height:"530px"}}>
                <img src={Window.react_data.images[3].image} className="w-full" style={{height:"260px", objectFit:"cover", marginBottom:"10px"}} />
                <img src={Window.react_data.images[4].image} className="w-full" style={{height:"260px", objectFit:"cover"}} />
                <button onClick={() => {this.setState({show_image_modal:true})}} className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border bg-[#dfff5d] border-[#dfff5d] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#cbe855] enabled:hover:border-[#cbe855] enabled:active:bg-[#9eb542] enabled:active:border-[#9eb542] absolute" style={{top:"75%", left:"50%", transform:"translate(-50%,-50%)"}}>{txt({location_id:"show_all_images", context_clue:"Text for button to show all images popup", text:"Visa alla bilder"})}</button>
            </div>
            {photographers}
        </div>
    }

    getLeaflet(){
        return <NHLeaflet geojson={Window.react_data?.forest?.geom} handleSectionClick={(id) => {this.refSections[id].current.setState({show_more:true})}} sections={Window.react_data.sections} />;
    }

    setVal(val, name, data_set){
        if(!this.state.hasOwnProperty(data_set)){
            this.state[data_set] = {}
        }
        this.setState({
            [data_set]:{...this.state[data_set], [name]:val}
        });
    }

    handleUpdate(name,id, extra_data){
        const formData = new FormData();
        let req_data = {}
        let data = data_map[name];
        let url = data.update_url + id + "/"
        let headers = {
            'credentials': 'same-origin',
            'X-CSRFToken': Cookies.get('csrftoken')
            }
        if(data.contentType){
            headers["Content-Type"] = data.contentType;
        }

        Object.keys(extra_data).map((key) => {
            formData.append(key, this.state[name][key]);
            req_data[key] = this.state[name][key]
        });

        
        Object.keys(data.fields).map((key) => {
            let val = this.state[name][key]
            if(data.formatters?.hasOwnProperty(key)){
                val = data.formatters[key].output(val);
            }
            if(val !== undefined){
                formData.append(key, val);
                req_data[key] = val
            }
            
        })

        fetch(url,  {
            method:"PATCH",
            headers: headers,
            body: (data.contentType ? JSON.stringify(req_data) : formData)
        }).then((resp) =>{
            if(resp.status < 300){
                window.location.reload();
            } 
        })

    }

    handleCreate(name, extra_data){
        const formData = new FormData();
        let req_data = {}
        let data = data_map[name];
        let url = data.create_url
        let headers = {
            'credentials': 'same-origin',
            'X-CSRFToken': Cookies.get('csrftoken')
            }
        if(data.contentType){
            headers["Content-Type"] = data.contentType;
        }
        
        Object.keys(extra_data).map((key) => {
            formData.append(key, this.state[name][key]);
            req_data[key] = this.state[name][key]
        });
        
        Object.keys(data.fields).map((key) => {
            let val = this.state[name][key]
            if(data.formatters?.hasOwnProperty(key)){
                val = data.formatters[key].output(val);
            }

            if(val !== undefined){
                formData.append(key, val);
                req_data[key] = val
            }
        })

        fetch(url,  {
            method:"POST",
            headers: headers,
            body: (data.contentType ? JSON.stringify(req_data) : formData)
        }).then((resp) =>{
            if(resp.status < 300){
                window.location.reload();
            } 
        })

    
    }

    handleDelete(name, id){
        let data = data_map[name];
        let url = data.update_url + id.toString() + "/"
        let headers = {
            'credentials': 'same-origin',
            'X-CSRFToken': Cookies.get('csrftoken')
            }
        fetch(url,  {
            method:"DELETE",
            headers: headers,
        }).then((resp) =>{
            if(resp.status < 300){
                window.location.reload();
            } 
        })
    }

    generateCreateForm(name, init_data, extra_data={}){
        let init_data_formatted = {...init_data}
        let jsx = <>
            {Object.keys(data_map[name].fields).map((key) => {
                let data = data_map[name].fields[key]
                let initial = null;
                if(init_data){
                    initial = init_data[key];
                    if(data_map[name].formatters?.hasOwnProperty(key)){
                        initial = data_map[name].formatters[key].input(initial);
                    }
                }
                init_data_formatted[key] = initial;

                let get_input_args =[data.label, initial, (val) => {this.setVal(val, key, name)}]
                if(data.window_options){
                    
                    get_input_args.push(Window.react_data[data.window_options])
                    console.log(get_input_args)
                }
                return <>{data.input.get_input(...get_input_args)} <br/></>
            })}
            <button className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-white bg-[#023436] border-[#023436] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#144143] enabled:hover:border-[#144143] enabled:active:bg-[#012526] enabled:active:border-[#012526]" onClick={() => {this.handleCreate(name, extra_data)}}>Create</button>
        </>
        
        this.setState({crudOffCanvas: jsx, [name]:{...init_data_formatted, ...extra_data}});
    }

    generateUpdateForm(name, id, init_data, extra_data={}){
        let init_data_formatted = {...init_data}
        let jsx = <>
        {Object.keys(data_map[name].fields).map((key) => {
            let data = data_map[name].fields[key]
            let initial = null;
            if(init_data){
                initial = init_data[key];
                if(data_map[name].formatters?.hasOwnProperty(key)){
                    initial = data_map[name].formatters[key].input(initial);
                }
            }
            init_data_formatted[key] = initial;

            let get_input_args =[data.label, initial, (val) => {this.setVal(val, key, name)}]
            if(data.window_options){
                
                get_input_args.push(Window.react_data[data.window_options])
                console.log(get_input_args)
            }
            return <>{data.input.get_input(...get_input_args)} <br/></>
        })}
        <button className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-white bg-[#023436] border-[#023436] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#144143] enabled:hover:border-[#144143] enabled:active:bg-[#012526] enabled:active:border-[#012526]" onClick={() => {this.handleUpdate(name, id, extra_data)}}>Update</button>
        {data_map[name].allow_delete ? <button className="transition-all duration-300 ease-out text-[.8em] text-center py-[11px] px-6 rounded-[30px] border text-[#2a2e33] bg-[#FF5B6C] border-[#FF5B6C] disabled:text-[#9d9fa1] disabled:bg-[#f5f5f5] disabled:border-[#f5f5f5] enabled:hover:bg-[#E85362] enabled:hover:border-[#E85362] enabled:active:bg-[#B5414D] enabled:active:border-[#B5414D] ml-1" onClick={() => {this.handleDelete(name, id)}}>Delete</button>:null}
        </>
        this.setState({crudOffCanvas: jsx, [name]:{...init_data_formatted, ...extra_data}});
    }

    subEmailUpdate(){

        if(!this.state.subTermsCheck){
            this.setState({subMessage: txt({location_id:"newsletter_incorrect_terms", context_clue:"User attemped to subscibe to newsletter but did not accept the terms", text:"Du måste acceptera våra villkor"})})
            return;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(String(this.state.subEmail).toLowerCase())){
            this.setState({subMessage: txt({location_id:"newsletter_incorrect_email", context_clue:"User attemped to subscribe to newsletter but the email they wrote was incorrect", text:"Du har angett en felaktig e-post"})})
            return;
        }


        let headers = {
            'credentials': 'same-origin',
            'X-CSRFToken': Cookies.get('csrftoken'),
            'Content-Type': "application/json"
            }
        fetch('/naturehub/api/project-email-notify/create/', {
            method:"POST",
            headers: headers,
            body: JSON.stringify({
                "email": this.state.subEmail,
                "project_id": Window.react_data.id
            })
        }).then((resp) => {
            if(resp.status > 100 && resp.status < 300){
                this.setState({subMessage: txt({location_id:"newsletter_success_message", context_clue:"User subscribed to newsletter with success", text:"Du kommer nu få mejl när uppdateringar sker i projektet"})})
            } else{
                this.setState({subMessage: txt({location_id:"newsletter_error_message", context_clue:"User attempted to subscribe to newsletter but some internal error occurred", text:"Något gick fel, var god försök igen"})})
            }
        })
    }

    getMobileOrder(){
        return <div className="flex flex-wrap">
            <div className="w-full gap-0">
            <div style={{width:"100%", height: "512px"}}>
                {/* leaflet go here */}
                {this.getLeaflet()}
            </div>
            </div>
        <div className="w-full">
            
            
            {this.getTopBar()}
            {this.getTabs()}
            {this.state.activeTab == 'overblick' ? this.getBuyBox() : null}
            {this.state.activeTab == 'overblick' ? this.getContactBox() : null}
            {this.state.activeTab == 'overblick' || this.state.activeTab == 'bilagor' ? this.getAttachmentBox() : null}
            {this.state.activeTab == "forandringsanalys" ? this.getChangeAnalysis() : null}
            {this.state.activeTab == 'overblick' ? this.getAboutBox() : null}
            {this.state.activeTab == 'overblick' ? this.getDetailsBox() : null}
            {this.state.activeTab == 'overblick' ? this.getSectionsBox(): null}
            {this.state.activeTab == 'overblick' ? this.getOtherInfoBox() : null}
            {this.state.activeTab == 'overblick' || this.state.activeTab == 'aktivitet' ? this.getUpdateBox() :null}
            {this.state.activeTab == 'overblick' ? this.getNewsletterBox() :null}
            {this.getRelatedProjectBox()}

        </div>
    </div>
    }

    getDesktopOrder(){
        return <div className="flex flex-wrap justify-between">
        <div className="w-[calc(66%-8px)]">
            {this.getTopBar()}
            <div style={{width:"100%", height: "512px"}} className="corners-1-eb corners-1-sb overflow-hidden">
                {/* leaflet go here */}
                {this.getLeaflet()}
            </div>

            {this.getTabs()}
            {this.getAboutBox()}
            {this.state.activeTab == "forandringsanalys" ? this.getChangeAnalysis() : null}
            {this.getDetailsBox()}
            {this.getSectionsBox()}
            {this.getOtherInfoBox()}
            {this.getUpdateBox()}
            {this.state.activeTab != "bilagor" ? null : this.getAttachmentBox()}
            {this.getRelatedProjectBox()}
        </div>
        <div className="w-[calc(33%-8px)]">
            {this.getBuyBox()}
            {this.getContactBox()}
            {this.getAttachmentBox()}
            {this.getNewsletterBox()}
        </div>
    </div>
    }

    render() {
        let has_untranslated = Object.keys(Window?.lang_data).reduce((acum, curr) => Window?.lang_data[curr].result_txt && !Window?.lang_data[curr].requires_update ? acum: true, false)

        return (
            <div>
                <div className="bg-white">
                    <Navigation ref={this.navigation} />
                </div>
                <div className="container neutral-charcoal mt-4 mb-12">
                    <a href="/">{txt({global:true, context_clue:"Breadcrumb for navigation to startpage", text:"Startsida"})}</a> > <a href="/biodiversitet/projekt/">{txt({location_id:"breadcrumb-bio-projectspage", context_clue:"Breadcrumb for navigation to projekts page", text:`${Window.react_data.attribute_label}`})}</a> >  {txt({location_id:"project_name", context_clue:"Property name (#id + designation)", text:`#NH${Window.react_data.id} - ${Window.react_data.property_designation}`})}
                </div>
                <div className="container neutral-charcoal mt-4">
                    <div className="flex flex-wrap justify-between">
                        <div className="lg:w-2/3 w-full">
                            <p className="text-[13px] leading-[120%] tracking-[-0.26px]+">{txt({location_id:"project_name", context_clue:"Property name (#id + designation)", text:`#NH${Window.react_data.id} - ${Window.react_data.property_designation}`})}</p>
                            <h1 className="text-[39px] leading-[122%] tracking-[-0.78px]">{txt({location_id:"project_title", context_clue:"Biodiversity project title", text:Window.react_data.title})} - {Window.react_data.property_designation}</h1>
                            <p className="text-[20px] leading-[120%] tracking-[-0.4px]"><NHTextCapper max_length={512} text={txt({location_id:"project_description", context_clue:"Project Description", text:Window.react_data.description})} /></p>
                        </div>
                        <div className="w-2/3 lg:w-1/6">
                            <NHEdit className="mb-4 float-right" onClick={() => {this.generateUpdateForm("project", Window.react_data.id.toString(), Window.react_data)}} />
                            {Window.react_data.is_editor ? <a className="block clear-both text-right text-[13px] underline mb-4" style={{cursor:"pointer"}} onClick={() => {this.generateUpdateForm("project_thumbnail", Window.react_data.id.toString(), Window.react_data)}}>Ändra miniatyrbild</a> : null}
                            <VBDropdown initial={Cookies.get("target_lang")} placeholder="Svenska" onChange={(opt) => {Cookies.set("target_lang", opt.value); window.location.reload()}} options={[
                                {"label": "Svenska", "value": "sv-se"}, 
                                {"label": "English", "value": "en-us"},
                                /*{"label": "Deutsch", "value": "de"},
                                {"label": "Soumi", "value": "fi"},
                                {"label": "Norsk", "value": "no"},
                                {"label": "Espanol", "value": "es"}*/
                                ]} inputStyle={{ minHeight: 0 }} />
                            <p className="text-[13px] leading-[120%] tracking-[-0.26px] mt-2">{txt({global:true, location_id:"bio_auto_translate_warn", text:"Översättning sker automatiskt och kan innehålla fel"})}</p>
                        </div>
                    </div>
                </div>
                <div className="container mt-4">
                    {screen.width >= 992 ? this.getDesktopOrder() : this.getMobileOrder()}
                </div>
                <Footer/>

            <TwModal isOpen={this.state.crudOffCanvas != null}>
                <TwModal.Header>
                    <div className="flex justify-end">
                        <button type="button" className="text-[20px] leading-[120%] tracking-[-0.4px] leading-none" onClick={() => this.setState({crudOffCanvas:null})} aria-label="Close">&times;</button>
                    </div>
                </TwModal.Header>
                <TwModal.Content>
                    <div style={{maxHeight:"60vh"}} className="overflow-auto">{this.state.crudOffCanvas}</div>
                </TwModal.Content>
            </TwModal>

            {(has_untranslated && Window.user_data.isAdmin) && <TxtTranslateModal />}
            
            </div >
        )
    }
}
export default NHDetails;